export default __webpack_public_path__ + "static/media/start_right.b54253d3.png";